import importSchema from './importSchema';

const getSchema = async (schemaName: string = 'default_flow') =>
  (await importSchema(schemaName)) ?? importSchema('default_flow');
export default getSchema;
